import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompetitors = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23.29 23.8",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		fill: "currentColor",
		d: "M20,3.32c-1.4-1.4-2.66-2.26-3.83-2.62-1.52-.47-2.91-.1-4.14,1.08-.1.1-.21.22-.34.35-.31-.22-.82-.49-1.5-.48-1.13.01-2.29.73-3.45,2.14-1.76,2.13-1.55,3.62-1.33,5.19.09.66.18,1.34.13,2.1L.77,15.86c-.36.36-.36.96,0,1.32l5.85,5.85c.18.18.42.27.66.27s.48-.09.66-.27l4.84-4.84c.4-.25.87-.53,1.37-.83,2.11-1.27,4.74-2.85,6.28-4.39,4.05-4.05,2.19-7.03-.43-9.64ZM7.38,22.46c-.05.05-.14.05-.19,0l-5.85-5.85c-.05-.05-.05-.14,0-.19l4.6-4.59,6.04,6.04-.87.87-4.51-4.51c-.16-.16-.41-.16-.56,0l-2.38,2.38c-.16.16-.16.41,0,.56l4.51,4.51-.78.78ZM8.72,21.12l-4.23-4.23,1.82-1.82,4.23,4.23-1.82,1.82ZM19.87,12.4c-1.47,1.47-4.05,3.02-6.13,4.27-.41.24-.8.48-1.15.69l-6.25-6.25c.05-.83-.05-1.55-.14-2.24-.21-1.51-.38-2.71,1.16-4.57.99-1.2,1.97-1.84,2.83-1.85.01,0,.02,0,.03,0,.43,0,.75.15.96.29-.6.73-1.27,1.64-1.69,2.35-.11.19-.05.43.14.55.19.11.43.05.55-.14.6-1.03,1.81-2.56,2.41-3.14,1.84-1.78,4.02-1.3,6.85,1.53,2.76,2.76,3.8,5.15.43,8.51Z"
	})
});
export default SvgCompetitors;
